export default __webpack_public_path__ + "static/media/marker-blue-orange-yellow.c9105cb6.png";